import { useMemo, useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LIST_TRUNCATE_EVENTS_MAX } from '../../constants/events';
import { styled } from '../../lib/styles';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDayGroupContainer = styled.div.withConfig({
  displayName: "DayGroup__StyledDayGroupContainer",
  componentId: "d2g79j-0"
})(["padding:16px 0 24px;"]);
export default function DayGroup({
  dayGroup,
  listViewMaxEventsPerDay
}) {
  const maxEventsPerDay = listViewMaxEventsPerDay || LIST_TRUNCATE_EVENTS_MAX;
  const canShowMore = dayGroup.children.length > maxEventsPerDay;
  const [showMore, setShowMore] = useState(false);
  const children = useMemo(() => canShowMore && !showMore ? dayGroup.children.filter((__c, i) => i < maxEventsPerDay) : dayGroup.children, [canShowMore, dayGroup.children, maxEventsPerDay, showMore]);
  const weekDay = dayGroup.day.format('dddd');
  const date = dayGroup.day.format('LL');
  return /*#__PURE__*/_jsx(StyledDayGroupContainer, {
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      "data-test-id": "list-view-row",
      children: [/*#__PURE__*/_jsx(H5, {
        id: `calendar-list-view-header-day-${I18n.moment.portalTz(dayGroup.day.valueOf()).format('YYYY-MM-DD')}`,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "calendar.listViewDate",
          options: {
            weekDay,
            date
          }
        })
      }), /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsxs(ScrollContainer, {
          position: "relative",
          gradientColor: 'fill-surface-default',
          children: [children, canShowMore && !showMore && /*#__PURE__*/_jsx(TFlex, {
            justify: "center",
            marginBlockStart: "100",
            children: /*#__PURE__*/_jsx(Button, {
              "data-test-id": "show-more-events-button",
              use: "link",
              onClick: () => setShowMore(true),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "calendar.viewMore",
                options: {
                  count: dayGroup.children.length - LIST_TRUNCATE_EVENTS_MAX
                }
              })
            })
          })]
        }), canShowMore && showMore && /*#__PURE__*/_jsx(Flex, {
          marginBlockStart: "100",
          justifyContent: "center",
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "show-less-events-button",
            use: "link",
            onClick: () => setShowMore(false),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "calendar.viewLess",
              options: {
                count: dayGroup.children.length - LIST_TRUNCATE_EVENTS_MAX
              }
            })
          })
        })]
      })]
    })
  });
}